// extracted by mini-css-extract-plugin
export default {"root":"IconCloseModal_root__kKdu0"};